import { gql } from '@apollo/client';

export const NSC_SUBJECT_DATA = gql`
  fragment nscSubjectData on NSCSubjectData {
    createdAt
    updatedAt
    id
    class
    dateAccessed
    dateCreated
    dataSource
    dateSchoolSubmitted
    emisNumber
    numberProgressed
    numberWroteProgressed
    numberAchievedProgressed
    subjectAverage
    numberAchieved
    numberAchievedProgressedLearners
    numberAchievedWithDistinction
    numberEnrolled
    numberProgressedLearners
    numberWrote
    numberWroteProgressedLearners
    percentageAchieved
    percentageAchievedProgressedLearners
    percentageAchievedWithDistinction
    term
    year
    subjectCode
    circuit {
      id
      name
    }
    cluster {
      id
      name
    }
    district {
      id
      name
    }
    grade {
      id
      value
    }
    institution {
      id
      emisNumber
      name
    }
    promotionStatus {
      id
      name
    }
    province {
      id
      name
    }
    region {
      id
      name
    }
    subject {
      id
      schoolReference
      languageLevel
      nationalCode
      name
      subjectGradeReference
    }
  }
`;
